import JSEncrypt from "jsencrypt";
import CryptoJS from "crypto-js";
const API_URL = "https://paywon.in/api/admin-api.php";

const RSA_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEApdPjKwS60GC5E1EA1qC/
NhpDbJZCqge7YUBGPO4ll21gyAqIACML7HR5uFI8rscllvQQ6oVDJyuqLFwbOH2d
Equ4Tr9W34BozQfbY8N7KtyAxCAzfljhjnzKjjXUFpNdl3WY3C9ymI9u+ywCnEdY
xP8Oa6LAJDxHh51UAqJzmlZY6FExfx4S2EhLQDvrnhsy+Z0Ovtq9L4AiS2HMcKtG
BROEz2KrcukCmcjE5O9sUik6GRQqJrNcoN2QpxqwJB1HhFYCT3VlH+Khf8H1Lx+e
eNOealbl/POqEKqP+cy1zDUGGyRZag/+55iT5EQSNR2BY2O7opISOzyt5xryNsjp
jQIDAQAB
-----END PUBLIC KEY-----`;


/* ===========================
   UTILS
=========================== */
const forceLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace("/login");
};

const generateAESKey = (length = 16) => {
    const charset =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let key = "";
    for (let i = 0; i < length; i++) {
        key += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return key;
};

/* ===========================
   APP META
=========================== */
const getAppMeta = async () => {
    return {
        appPlatform: "web",
        appVersion: "1.0.0",
        buildNumber: "1",
    };
};

/* ===========================
   HYBRID ENCRYPTION (AES-128)
=========================== */
export const encryptDataHybrid = (jsonData) => {
    try {
        // 1️⃣ Generate 16-char AES key (AES-128)
        const aesKey = generateAESKey(16);
        const aesKeyWord = CryptoJS.enc.Utf8.parse(aesKey);

        // 2️⃣ AES-128-ECB encrypt
        const encryptedData = CryptoJS.AES.encrypt(
            JSON.stringify(jsonData),
            aesKeyWord,
            {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
            }
        ).toString(); // Base64

        // 3️⃣ RSA encrypt AES key (PKCS1 v1.5)
        const rsa = new JSEncrypt();
        rsa.setPublicKey(RSA_PUBLIC_KEY);

        const encryptedKey = rsa.encrypt(aesKey);
        if (!encryptedKey) throw new Error("RSA encryption failed");

        return {
            encryptedData,
            encryptedKey,
        };
    } catch (error) {
        console.error("❌ Encryption failed:", error);
        return null;
    }
};

/* ===========================
   API CALL
=========================== */
export const apiCall = async (
    api,
    payload = {},
    isLoggedIn = true,
    header = {}
) => {
    try {
        let user_id = "";
        let token = "";

        if (isLoggedIn) {
            const storedUserData = localStorage.getItem("credentials");
            const parsedData = JSON.parse(storedUserData);

            user_id = parsedData?.user_id || '';
            token = parsedData?.login_token || '';

            if (!parsedData?.user_id || !parsedData?.login_token)
                return forceLogout();
        }

        const { appPlatform, appVersion, buildNumber } = await getAppMeta();

        // 🔐 Encrypt full request
        const encrypted = encryptDataHybrid({
            appPlatform,
            appVersion,
            buildNumber,
            user_id,
            token,
            api,
            payload,
        });

        console.log({
            appPlatform,
            appVersion,
            buildNumber,
            user_id,
            token,
            api,
            payload,
        });

        if (!encrypted) throw new Error("Encryption failed");

        const timestamp = Math.floor(Date.now() / 1000);

        const response = await fetch(`${API_URL}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${timestamp * 784116}`,
                ...header,
            },
            body: JSON.stringify({
                encryptedData: encrypted.encryptedData,
                encryptedKey: encrypted.encryptedKey,
            }),
        });

        if (!response.ok) throw new Error("Server error");

        const result = await response.json();

        if (result.response_code === 7) {
            forceLogout();
        }

        if (result.response_code === 6) {
            window.open(result.message, '_blank');
        }

        return result;
    } catch (error) {
        throw new Error(error.message || "API call failed");
    }
};
